module.exports = __webpack_public_path__ + "img/order.d1bc7514.png";